<template>
  <div class="map-editor-layer-header">
    <r-icon
      :name="editorState.modelLayers.length ? 'model' : getGeomIcon()"
      :size="14"
    />
    <r-text>
      {{ editorState.name }}
    </r-text>
  </div>
</template>

<script>
import { geomTypesIcon } from "@/config/geom-types";

export default {
  props: ["editor-state"],
  methods: {
    getGeomIcon() {
      console.log(`${geomTypesIcon[this.editorState.geom_type]}`);

      return `${geomTypesIcon[this.editorState.geom_type]}`;
    }
  }
};
</script>

<style lang="scss">
.map-editor-layer-header {
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid transparent;
  border-color: var(--dividers_low_contrast) !important;

  .r-icon {
    margin-right: 8px;
    width: auto;
  }
}
</style>
